import { initSensors, dataTrack } from '@nio-fe/challenger-data-track';
// import { getEnv } from '@/root/request/env'
import { getEnv } from './index'

const getEnvCode = () => {
    let env = getEnv();
    console.log('env>>>', env);
    return env == 'prod' ? 3 : 0
}
const isProd = getEnvCode()==3
const prodServerUrl =  'https://sensors.nio.com/sa?project=nio_business_prod';
const testServerUrl = 'https://sensors.nio.com/sa?project=nio_business_test';


export const initTrack = (param) => {
    initSensors({
        // util.getEnvCode 是项目中自定义的获取环境code的方法，3则为生产环境，否则为测试环境。
        prodServerUrl: prodServerUrl,
        testServerUrl: testServerUrl,
        envCode: getEnvCode(),
        isProd: getEnvCode()==3?true:false, // 表达式为真，说明是生产环境，否则为测试环境
        use_auto_track_click: true, // 开启自动上报点击事件埋点
        use_auto_track_expo: true, // 开启自动上报元素曝光事件埋点
        use_auto_track_duration:true,
        auto_track_exposure_options: { // 元素曝光事件埋点相关配置项
            area_rate: 1, // 曝光比例。默认：1，值域：0~1。类型：Number
            stay_duration: 0, // 有效曝光停留时长。 默认：0。类型：Number
            repeated: true, // 重复曝光。 默认：true。类型：Boolean
        },
        ...param  
    });
}

